<template>
    <div>
        <b-modal
            :visible="value"
            size="lg"
            @cancel="cancel"
            @close="cancel"
            @ok="save"
            @hidden="hidden"
        >
            <template #modal-title>
                Edit Link
            </template>

            <b-form-group label="Link Src">
                <b-input type="text" placeholder="https://..." v-model="editableLink.url"></b-input>
            </b-form-group>

            <template #modal-footer>
                <b-button variant="light" @click="cancel">
                    Cancel
                </b-button>
                <b-button variant="primary" @click="save">
                    Save Changes
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: "LinkExtensionModal",
    data: () => ({
        editableLink: {
            url: 'https://'
        },
    }),
    props: [
        'value',
        'view',
        'link'
    ],
    watch: {
        value: {
            handler (value) {
                if (value == true) {
                    if (this.link) {
                        this.editableLink = this.link;
                    }
                }
            }
        }
    },
    methods: {
        save() {
            this.$emit('save',this.editableLink);
        },
        cancel() {
            event.preventDefault()

            this.$emit('hide')
        },
        hidden () {
            this.$emit('hide')

            if (
                this.view &&
                this.view.dom
            ) {
                this.view.dom.focus()
            }
        }
    }
}
</script>

<style scoped>

</style>